import {requestParalegal ,requestOrder ,requestCore} from '../libs/axios'

// 会员管理
export const getVipInfo = (params) => requestParalegal.post('/lawyerVip/getLawyerVipInfo', params) // 会员信息
export const getVipInfoList = (params) => requestParalegal.post('/vip/getVipInfoList', params) // 会员列表
export const getVipClass = (params) => requestParalegal.post('/lawyerVip/getVipClass', params) // 可用的购买会员分类
export const walletBalance = (params) => requestParalegal.post('/wallet/balance', params) // 钱包余额
export const vipPay = (params) => requestOrder.post('/vip/pay', params) // 会员下单
export const queryOrderPay = (params) => requestOrder.post('/vip/query/'+params.orderNo) // 可用的购买会员分类
export const vipPaySmsCheck = (params) => requestOrder.post('/vip/pay/smsCheck', params) // 支付验证
export const sendSmsAgain = (params) => requestOrder.post('/vip/sms/sendSmsAgain',params) // 再次发送验证码
export const userAgreement = (params) => requestCore.post('/user/agreement',params) // 再次发送验证码
